import { useState } from 'react';

import { type TFlatBlock } from './helpers/blocksToFlatDocument';

export type TBlockStatus = {
  id: string;
  index: number;
  flatBlock: TFlatBlock;
};

export default function useBlockState() {
  return useState<TBlockStatus | null>(null);
}
